<!-- div con fondo gris claro -->
<div class="container">

Modulo: <app-selectorformulario></app-selectorformulario>
Encuesta: <p-dropdown [options]="encuestas" [(ngModel)]="encuestaSeleccionada"  placeholder="Seleccione una encuesta" (onChange)="onEncuestaCambiada($event.value)"></p-dropdown>
</div>


<div style="background-color: #ffffff;" class="container">

<p-tabMenu [model]="items" [activeItem]="activeItem" (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>


<div *ngIf="activeItem.label === 'Propiedades'">
    <app-form-propiedades [id]="id"></app-form-propiedades>
</div>
<div *ngIf="activeItem.label === 'Formulario'">
    <app-editarformulario></app-editarformulario>
</div>
<div *ngIf="activeItem.label === 'Encuestas'">
    <app-encuestas (verResultados)="onVerResultados($event)" (encuestaCreada)="actualizarLista()"></app-encuestas>
</div>
<div *ngIf="activeItem.label === 'Resultados'">
    <app-form-resultados></app-form-resultados>
</div>
<div *ngIf="activeItem.label === 'Precargar'">
    <app-form-precargar></app-form-precargar>
</div>
<div *ngIf="activeItem.label === 'Devolver'">
    <app-form-devolver></app-form-devolver>
</div>
<div *ngIf="activeItem.label === 'Usuarios'">
    <app-form-usuarios></app-form-usuarios>
</div>
<div *ngIf="activeItem.label === 'Estadísticas'">
    <app-form-estadisticas></app-form-estadisticas>
</div>

    
</div>



